import { create } from "zustand";
import axios from "axios";

type AuthStatus = "valid" | "expired" | "missing" | "error";

interface ClaudeCodeAuthState {
  authStatus: AuthStatus;
  isLoading: boolean;
  fetchAuthStatus: (
    canvasId: string,
    getToken: () => Promise<string | null>,
  ) => Promise<void>;
  reset: () => void;
}

export const useClaudeCodeAuthStore = create<ClaudeCodeAuthState>(
  (set, get) => ({
    authStatus: "valid",
    isLoading: false,

    fetchAuthStatus: async (canvasId, getToken) => {
      // Prevent concurrent requests
      if (get().isLoading) return;

      try {
        set({ isLoading: true });

        const token = await getToken();
        if (!token) {
          set({ authStatus: "missing", isLoading: false });
          return;
        }

        const response = await axios.get(
          `${
            import.meta.env.VITE_BACKEND_BASE_URL
          }/canvases/${canvasId}/claude-code/ensureAuth?authHeader=Bearer ${encodeURIComponent(
            token,
          )}`,
        );

        const { status, credentialsFound } = response.data;

        if (status !== undefined) {
          set({ authStatus: status, isLoading: false });
        } else if (credentialsFound !== undefined) {
          console.warn("[Auth] Using legacy credentialsFound format");
          set({
            authStatus: credentialsFound === true ? "valid" : "missing",
            isLoading: false,
          });
        } else {
          console.error("[Auth] Unexpected response format:", response.data);
          set({ authStatus: "error", isLoading: false });
        }
      } catch (err: any) {
        console.error("[Auth] Error fetching auth status:", err);
        set({ authStatus: "error", isLoading: false });
      }
    },

    reset: () => {
      set({ authStatus: "valid", isLoading: false });
    },
  }),
);
